import { useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const useProfileDashboard = () => {
  const { baseUrl, basicAuth, userID } = useContext(GlobalContext);

  const headers = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  // ORGANIZATION DETAILS
  const fetchOrganizationDetails = async (userid) => {
    const res = await axios.post(
      `${baseUrl}/User/getOrganizationDetails`,
      { userid: userID },
      headers,
    );
    return res.data;
  };

  // UPDATE ORGANIZATION
  const updateOrganizationInfo = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/User/editOrganizationInfo`,
      payload,
      headers,
    );
    return res.data;
  };

  // INVOICE HISTORY
  const fetchInvoices = async (userid) => {
    const res = await axios.post(
      `${baseUrl}/Entitlement/getAllUserSubscriptions`,
      { userid: userID },
      headers,
    );
    return res.data;
  };

  // WHATSAPP CREDENTIALS
  const getWhatsappCredentials = async (userid) => {
    const res = await axios.post(
      `${baseUrl}/Whatsapp/getWhatsappCredentials`,
      { userid: userID },
      headers,
    );
    return res.data;
    
  };

  // CANCEL SUBSCRIPTION
  const cancelSubscription = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/Entitlement/cancelSubscriptionPlan`,
      payload,
      headers,
    );
    return res.data;
  };

  // GET RECEIPT DATA
//  const fetchReceiptDetails = async () => {
//   try {
//     const res = await axios.post(
//       `${baseUrl}/Order/getReceiptData`,
//       { userid: userID },
//       headers,
//     );

//     if (res.data?.responseCode === "00") {
//       return res.data.response?.[0] || null; 
//     }

//     return null;
//   } catch (err) {
//     console.error(err);
//     return null;
//   }
// };

const fetchReceiptDetails = async () => {
  try {
    const res = await axios.post(
      `${baseUrl}/Order/getReceiptData`,
      { userid: userID },
      headers,
    );

    if (res.data?.responseCode === "00") {
      return res.data; 
    }

    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

  // UPDATE RECEIPT DATA
  const updateReceiptInfo = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/Order/editReceiptData`,
      payload,
      headers,
    );
    return res.data;
  };

  // GET BANK LIST
  const getBankAccounts = async (userid) => {
    const res = await axios.post(
      `${baseUrl}/Transactions/getSettlementAccountList`,
      { userid: userID },
      headers,
    );
    return res.data;
  };

  // ADD BANK
  const addBankAccount = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/Transactions/addSettlementAccount`,
      payload,
      headers,
    );
    return res.data;
  };

  // FETCH ALA CARTE
  const fetchAlaCartePlans = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/Entitlement/fetchAlaCarte`,
      payload,
      headers,
    );
    return res.data;
  };

  // BUY SUBSCRIPTION PLAN
  const buySubscriptionPlan = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/Entitlement/buySubscriptionPlan`,
      payload,
      headers,
    );
    return res.data;
  };

  // UPGRADE SUBSCRIPTION PLAN
  const upgradeSubscriptionPlan = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/Entitlement/upgradeSubscriptionPlan`,
      payload,
      headers,
    );
    return res.data;
  };

  // BUY ADDONS
  const buyAddOns = async (payload) => {
    const res = await axios.post(
      `${baseUrl}/Entitlement/buyAddOns`,
      payload,
      headers,
    );
    return res.data;
  };

  // ADD WHATSAPP CREDENTIALS
const addWhatsappCredentials = async (payload) => {
  const res = await axios.post(
    `${baseUrl}/Whatsapp/addWhatsappCredentials`,
    payload,
    headers,
  );
  return res.data;
};

// GET DASHBOARD DATA
const getDashboardData = async (payload) => {
  const res = await axios.post(
    `${baseUrl}/Whatsapp/getDashboardData`,
    payload,
    headers,
  );
  return res.data;
};

  return {
    fetchOrganizationDetails,
    updateOrganizationInfo,
    fetchInvoices,
    getWhatsappCredentials,
    cancelSubscription,
    fetchReceiptDetails,
    updateReceiptInfo,
    getBankAccounts,
    addBankAccount,
    fetchAlaCartePlans,
    buySubscriptionPlan,
    upgradeSubscriptionPlan,
    buyAddOns,
    addWhatsappCredentials,
    getDashboardData,
  };
};

export default useProfileDashboard;
